import styled from 'styled-components';
import media from '../../../../styles/media.style';

export const Background = styled.div`
  width: 100%;
  height: 100vh;
`;

export const BackgroundImage = styled.div`
  height: 100vh;
  position: fixed;
  width: 100%;
  z-index: -1;

  img {
    height: 100%;
    max-height: 100%;
    max-width: 100%;
    object-fit: cover;
    opacity: 1;
    width: 100%;
    filter: blur(10px);
    transition: all 250ms ease-in-out 0s;
  }
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
  text-align: center;
  .placeholder_Box {
    margin-bottom: 30px;
  }
`;

export const Title = styled.h1`
  font-size: 20px;
  margin-bottom: 20px;
  padding: 0 34px;
  ${media.tabletP`
    font-size: 30px;
    padding: 0;
  `};
`;

export const Description = styled.p`
  color: #000;
  font-size: 14px;
  line-height: 1.75;
  margin-bottom: 30px;
  padding: 0 34px;
  ${media.tabletP`
    font-size: 18px;
    margin-bottom: 35px;
    padding: 0;
  `};
`;

export const StartButton = styled.button`
  display: block;
  margin: 0 auto;
  font-size: 14px;
  width: 300px;
  height: 50px;
  color: #fff;
  background: #8a9094;
  margin-bottom: 30px;
  border: none;
  ${media.tabletP`
    font-size: 18px;
    height: 65px;
    margin-bottom: 40px;
  `};
`;

export const SkipLink = styled.a`
  color: #000;
  font-size: 13px;
  ${media.tabletP`
    font-size: 16px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisPage/EmotionalPage/EmotionalPage.style.js